<script>
    import {removeTemporaryAnalyze, removeAnalyze} from "../lib/ApiRequests.svelte";
    import LoadingIcon from "./LoadingIcon.svelte";
    import {num_word} from "../lib/Common.svelte";
    import {onDestroy, onMount} from "svelte";
    import {_} from '../lib/i18n';

    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';
    export let analyze;

    export let showDelete = false;
    export let isDeletable = false;

    export let deletableDate = new Date();

    let photo;
    $: photo = (analyze && analyze.account) ? analyze.account.photo : '';
    let username;
    $: username = (analyze && analyze.account) ? analyze.account.username : '';

    let analyzeStartedAt;
    $: analyzeStartedAt = (analyze && analyze.date_start_epoch) ? new Date(analyze.date_start_epoch * 1000) : new Date();

    let analyzeDeletableAt = deletableDate;

    let deletionAvailableIn = '';
    let refreshInterval;
    onMount(() => {
        refreshInterval = setInterval(() => {
            const now = new Date();
            let delta = Math.abs(analyzeDeletableAt - now) / 1000;

            const days = Math.floor(delta / 86400);
            delta -= days * 86400;

            const hours = Math.floor(delta / 3600) % 24;
            delta -= hours * 3600;

            const minutes = Math.floor(delta / 60) % 60;
            delta -= minutes * 60;

            const seconds = delta % 60;  // in theory the modulus is not required

            deletionAvailableIn = $_('settingsTargetInfoBlock.deletionAvailableAt', {
                values: {
                    days,
                    dayForm: num_word(days, [$_('settingsTargetInfoBlock.dayForm1'), $_('settingsTargetInfoBlock.dayForm2'), $_('settingsTargetInfoBlock.dayForm3')]),
                    hours,
                    minutes,
                },
            });
        }, 1000);
    });

    onDestroy(() => {
        if (refreshInterval) {
            clearInterval(refreshInterval);
        }
    });


    function toggleDeleteForm() {
        showDelete = !showDelete;
    }

    function showDeleteForm() {
        showDelete = true;
    }

    function hideDeleteForm() {
        showDelete = false;
    }

    let deleteInProgress = false;
    async function deleteAnalyze() {
        deleteInProgress = true;

        let success = false;
        if (analyze.temporary) {
            try {
                const response = await removeTemporaryAnalyze(analyze.account.instagram_id);
                if (response.status === 'ok') {
                    success = true;
                    window.location.reload();
                }
            } catch (err) {
                console.error(err)
            }
        } else {
            try {
                const response = await removeAnalyze(analyze.id);
                if (response.status === 'ok') {
                    success = true;
                }
            } catch (err) {
                console.error(err)
            }
        }

        if (success) {
            try {
                if (params && params.removeAnalyze instanceof Function) {
                    params.removeAnalyze(analyze.id);
                }
            } catch (err) {
                console.error(err)
            }
            showDelete = false;
        }

        deleteInProgress = false;
    }

    function onImageError(event) {
        event.target.src = '/spy20-lk/icons/avatar-empty.svg';
    }
</script>


<div class="target-item">
    <div class="target-item__header">
        <div class="target-item__header-wrapper">
            <img src={photo} alt="avatar" class="target-item__avatar" on:error={onImageError} />
            <div class="target-item__info">
                <p class="target-item__label">{$_('settingsTargetInfoBlock.targetLabel')}:</p>
                <div class="target-item__name">@{username}</div>
            </div>
        </div>

        <button disabled={!isDeletable} class="button button_textual target-item__btn" on:click={showDeleteForm}>
            {$_('settingsTargetInfoBlock.removeLabel')}
        </button>
    </div>

    {#if !isDeletable && analyzeDeletableAt}
    <p class="target-item__disclaimer">
        {@html $_('settingsTargetInfoBlock.deletionAvailableInLabel', {
            values: { username },
        })}: {deletionAvailableIn}
    </p>
    {/if}

    {#if isDeletable && showDelete}
    <div class="target-item__delete system-info system-info_red">
        <div class="target-item__delete-title-wrapper system-info__title-wrapper">
            <div class="target-item__delete-title-icon system-info__title-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="9.99935" cy="14.1667" rx="0.833333" ry="0.833333" fill="#161516" />
                    <path d="M10 8.33334L10 11.6667" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3.11323 14.6056L8.21049 4.41105C8.94754 2.93695 11.0512 2.93695 11.7882 4.41105L16.8855 14.6056C17.5504 15.9354 16.5834 17.5 15.0966 17.5H4.90208C3.41532 17.5 2.44833 15.9354 3.11323 14.6056Z" stroke="#161516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
            <h3 class="target-item__delete-title-text system-info__title-text">{$_('settingsTargetInfoBlock.targetDeletionBlockTitle', {
                values: { username },
            })}</h3>
        </div>
        <p class="target-item__delete-text system-info__text">{@html $_('settingsTargetInfoBlock.targetDeletionConfirm', {
            values: { username },
        })}</p>
        <div class="target-item__delete-controls-wrapper system-info__controls-wrapper">
            <div class="button button_ghost system-info__controls-btn system-info__controls-btn_main target-item__delete-btn target-item__delete-btn_main" on:click={hideDeleteForm}>
                {$_('settingsTargetInfoBlock.cancelDelete')}
            </div>
            <div class="button button_textual system-info__controls-btn system-info__controls-btn_secondary target-item__delete-btn target-item__delete-btn_secondary"
                 on:click={deleteAnalyze}>
                <LoadingIcon show={deleteInProgress} height="16" width="16" color="#161516" />
                {$_('settingsTargetInfoBlock.confirmDelete')}
            </div>
        </div>
    </div>
    {/if}
</div>


<style>
    .target-item__avatar {
        border-radius: 100%;
    }
</style>